export const currentWeatherResponse = {
	coord: {
		lon: 13.4105,
		lat: 52.5244,
	},
	weather: [
		{
			id: 804,
			main: 'Clouds',
			description: 'overcast clouds',
			icon: '04n',
		},
	],
	base: 'stations',
	main: {
		temp: 4.85,
		feels_like: 3.42,
		temp_min: 3.9,
		temp_max: 5.5,
		pressure: 1034,
		humidity: 85,
		sea_level: 1034,
		grnd_level: 1028,
	},
	visibility: 10000,
	wind: {
		speed: 1.79,
		deg: 270,
	},
	clouds: {
		all: 100,
	},
	dt: 1732901176,
	sys: {
		type: 2,
		id: 2011538,
		country: 'DE',
		sunrise: 1732863129,
		sunset: 1732892267,
	},
	timezone: 3600,
	id: 2950159,
	name: 'Berlin',
	cod: 200,
};
